// extracted by mini-css-extract-plugin
export default {"content":"style_content__d7J5S","leftSide":"style_leftSide__cuf6J","rightSide":"style_rightSide__0UE1P","type":"style_type__+NyON"};